import { useEffect, useLayoutEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet, useNavigate, useSearchParams, useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { IS_APP_LIGHT } from 'shared/config'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { WebMcpProvider } from 'entities/WebMcp'
import { AiAgentLauncher } from 'features/AiAgent'
import { isSuperAdminPath } from 'app/shared/lib/isSuperAdminPath'

export const RootLayout = observer(({ showAiAgent = false }: { showAiAgent?: boolean }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [loading, setLoading] = useState(false)
  const entities = useEntitiesContext()
  const { authStore } = entities
  const inSuperAdmin = isSuperAdminPath(location.pathname)

  useLayoutEffect(() => {
    uiStore.setLocation(location)
  }, [location])

  useEffect(() => {
    uiStore.setSearchParamsToUIStore(searchParams)
  }, [searchParams])

  useEffect(() => {
    uiStore.setNavigate(navigate)
    uiStore.setSearchParamsSetterToUIStore(setSearchParams)

    if (window.RouterVue && !loading && !IS_APP_LIGHT) {
      const currentRoute = window.RouterVue.currentRoute

      const routeParamsState = currentRoute?.value?.params?.state

      if (currentRoute.value.path !== '/') {
        uiStore.changeRoute({
          path: `${currentRoute.value.path}${window.location.search}`,
          method: 'replace',
          options: routeParamsState
            ? {
                state: routeParamsState,
              }
            : undefined,
        })
      }
    }

    setLoading(true)

    const external_source = searchParams.get('external_source')
    const close_after_login = searchParams.get('close_after_login')
    if (external_source) {
      authStore.setExternalSource(external_source)
    }
    if (close_after_login) {
      authStore.setCloseAfterLogin(!!close_after_login)
    }
  }, [])

  return (
    <>
      <Outlet />
      {!inSuperAdmin && <WebMcpProvider />}
      {showAiAgent && !inSuperAdmin && <AiAgentLauncher />}
    </>
  )
})
